import React, { useEffect, useState } from "react";
import SaleOff from "../../Products/SaleOff";
import { RoundFloor } from '../../../utils/format'
import { actionCart } from '../../../service/cartService';
import { checkWWishlist, deleteWishlist, createWishlist, addProductToWishlist } from '../../../service/wishlistService';
import { toast } from "react-toastify";
import { FromatNumberVIE } from '../../../utils/format';
import "react-multi-carousel/lib/styles.css";
import Img from "../../Images";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import './item.css';
import { isAuth } from "../../../helpers/general";
import { pushtracking } from "../../../service/trackingService";
import { useLocation } from "@reach/router";
const ItemHotDeal = ({ item, index }) => {
    const percen = +item?.price['discount'] / item.price['raw'] * 100;
    const location = useLocation();
    const handleAddToCart = (item, uri) => {
        if (isAuth() === false) {
            //toast.error('Bạn cần đăng nhập trước khi mua hàng.');
            setTimeout(() => { window.location.href = '/dang-nhap.html' }, 3500);
        } else {
            if (item.sku.includes('C') === true || +item.typePromotion === 3) {
                window.localStorage.setItem('typepage', 'product');
                window.location.href = uri;
            } else {
                let params = {
                    items: [{
                        product: item.sku,
                        type: 'item',
                        action: 'add',
                        quantity: 1,
                        promo_code: item.promoCode?? "",
                        combo_code: item.combCode ?? '',
                        uudai: item.uuDai,
                        user_referral:  window.localStorage.getItem('userReferral'),
                        id_share:   window.localStorage.getItem('idShare')
                    }]
                }
                try {
                    actionCart(params, window.localStorage.getItem('key')).then((response) => {
                        if(+response.status === 200 && response.message?.length > 0){
                        localStorage.removeItem("itemsCart");
                        localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                        window.localStorage.setItem('reloadCart', true);
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push({
                                'event': 'add_to_cart',
                                'ecommerce': {
                                'currency': "VND",
                                'value': +item.price?.import,
                                    'items': [
                                    {
                                        item_id: item.sku,
                                        item_name: item.name,
                                        price: +item.price?.import
                                    }
                                    ]
                                }
                            });
                            try{
                                pushtracking(window.localStorage.getItem('sessionId')??null,
                                window.localStorage.getItem('_id')??null,
                                window.localStorage.getItem('phone')??null ,
                                location.pathname, "Thêm sản phẩm vào giỏ hàng", 0,0,'index','inWeb',[item.sku],'Website Mobile').then((response)=>{
                                    console.log('send tracking');
                                });
                            }catch(e){console.log(e)}
                        toast.success('Thêm vào giỏ hàng thành công.'); 
                    }
                    });
                } catch (err) {
                    console.log(err);
                }
            }
        }
    }
    const handleRedirect = (uri) => {
        if(uri !== '/undefined'){
            window.location.href =  uri;
        }
    }
    return (
        <li key={index}>
            <div className="col-4 img-item in-f" onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))}>
                <div className="img-item-hotdeal-home">
                    <img src={item.thumbnail} alt={item.name} title={item.name}/>
                </div>
            </div>
            <div className="col-8 mgt-5">
                <div className="col-12 box-name-item d-flex mgt-10" onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))}>
                    {/* <h1 className="d-none">{item?.name}</h1> */}
                    <span className="name-item">
                        {
                            item?.name?.length > 80 ? ((item?.name).substring(0, 80) + '...') : (item?.name)
                        }
                    </span>
                </div>
                <div className="col-12 d-flex mgt-15">
                    <span className="price-sale">
                        {
                            +item?.price['discount'] < +item?.price['raw'] ? (
                                FromatNumberVIE(item?.price['raw'])
                            ) : (null)
                        }đ
                    </span>
                </div>
                <div className="item-sale">
                    <span className="price-now">
                        {
                            +item?.price['raw'] > +item?.price['discount'] ? (
                                FromatNumberVIE(item?.price['discount'])
                            ) : (null)
                        }đ
                    </span>
                    <div className="box-price-percent in-f">
                        <span className="price-percent">-
                            {
                                +item.price['discount'] !== +item.price['raw'] ? (<SaleOff key={index}
                                    percen={RoundFloor(100 - percen)} />) : (null)
                            }
                        </span>
                    </div>
                </div>
                <div className="row mgt-5 mgx-0">
                    <div className="col-10 nav-available pdx-0 pdr-5">
                        <div className="available-item">
                            <span className="color_width" data-title="0" data-toggle="tooltip" style={{ "width": +item.hotdeal?.total > +item.hotdeal?.quantity ? ((+item.hotdeal?.quantity / +item.hotdeal?.total) * 100 - 5) : (0) }} data-original-title="" title=""></span>
                        </div>
                        <img className="image-animation" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/Vector.png" alt="icon" style={{ "left": +item.hotdeal?.total > +item.hotdeal?.quantity ? ((+item.hotdeal?.quantity / +item.hotdeal?.total) * 100 - 5) : (0) }} />
                        <span className="available-text">Còn {+item.hotdeal?.quantity} sản phẩm</span>
                    </div>
                    <div className="col-2 pdl-10">
                        <img className="svg-addcart" onClick={() => handleAddToCart(item, '/' + item.linksp?.replace('/', ''))} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_addcart.png" alt="icon"/>
                    </div>
                </div>
            </div>
        </li>
    )
}

const ItemProductGift = ({ item, index }) => {
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    const percen = +item?.price['discount'] / item.price['raw'] * 100;
    const location = useLocation();
    const handleAddToCart = (item, uri) => {
        if (isAuth() === false) {
            //toast.error('Bạn cần đăng nhập trước khi mua hàng.');
            setTimeout(() => { window.location.href = '/dang-nhap.html' }, 3500);
        } else {
            window.location.href = uri;
        }
    }
    const handleRedirect = (uri) => {
        if(uri !== '/undefined'){
            // window.location.href = '/mobile/chi-tiet-mua-hang-tang-qua'+uri;
            window.location.href = uri;
        }
    }
    const [wishlist, setWishlist] = useState(false);
    const handleWishlist = (sku, isFavorite) => {
        if (window.localStorage.getItem('key')) {
            setWishlist(!wishlist);
            checkWWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                console.log(response);
            })

            if (isFavorite) {
                deleteWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                    console.log(response);
                })
            } else {
                let param = {
                    "code": window.localStorage.getItem('_id'),
                    "user_id": window.localStorage.getItem('_id'),
                    "name": "danh-sach-yeu-thich",
                    "source": "cusapp",
                    "type": "",
                };
                createWishlist(param).then((response) => {
                    if (+response.status === 200) {
                        let data = {
                            "wishlist_id": window.localStorage.getItem('_id'),
                            "user_id": window.localStorage.getItem('_id'),
                            "product_id": sku,
                        };
                        addProductToWishlist(data).then((response) => {
                            console.log(response);
                        })
                    }
                })
            }
        }
    }
    const settings1 = {
        dots: false,
        infinite: true,
        autoplay: true,
        speed: 100,
        slidesToShow: 1,
        slidesToScroll: 1
      };
    return (
        <li key={index} >
            <div className="box-detail">
                <div className="col-12 img-item in-f position-relative img-item-list-product" >
                    {
                        item.thumbnail_gifts?.length>0 ? (
                            <div>
                                
                            <div className="d-flex justify-content-center position-absolute text--tang">
                                <div className="button--tang position-relative d-inline-block text-center rounded-pill text-white px-2">Tặng</div>
                            </div>
                           <div className="img--grif position-absolute">
                             <Slider {...settings1}>
                                {
                                    item.thumbnail_gifts?.map((imggift, i)=>(
                                            <a href={'/' + item.linksp?.replace('/', '')}>
                                            <Img key={i} imgTitle={item.name} url={imggift} className="w-100" style=""/>
                                            </a>
                                    ))
                                }
                                </Slider>
                            </div>
                            <div className="position-absolute icon--tang">
                                    <img  src="/static/image/icon_tang.svg" alt="icon"/>
                            </div>
                        </div>
                        ):(null)
                    }
                    <div className="img-item-hotdeal">
                        <img onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))} className="" src={item.thumbnail} alt={item.name} title={item.name}/>
                    </div>
                    
                    <img onClick={() => handleWishlist(item.sku, item.isFavorite)} className="img-like" src={wishlist || item.isFavorite ? ("/../images/web_app/ic_like_active.svg") : ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_like.png")} alt="icon" title="icon"/>
                    {
                        +item?.price['discount'] !== +item?.price['raw'] ? (<div className="box-sale-percent"><span>{RoundFloor(100 - percen)}%</span></div>) : (null)
                    }
                </div>
                <div className="col-12 box-name-item pdx-8 d-flex" onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))}>
                {/* <h1 className="d-none">{item?.name}</h1> */}
                    <span className="name-item">{
                        item?.name?.length > 50 ? ((item?.name).substring(0, 50) + '...') : (item?.name)
                    }</span>
                </div>
                <div className="col-12 mgt-5 pdx-8">
                    <span className="price-item">
                        {
                            +item?.price['discount'] < +item?.price['raw'] ? (
                                FromatNumberVIE(item?.price['raw'])
                            ) : (FromatNumberVIE(item?.price['discount']))
                        }đ</span>
                </div>
                <div className="col-12 in-f mgt-5 mgb-5 pdx-8">
                    <div className="col-10 box-list box-item-sale-bg mgr-5">
                        <span>Mua là có Quà</span>
                    </div>
                    <div className="col-2 in-f">
                        <img className="svg-addcart" onClick={() => handleAddToCart(item, '/' + item.linksp?.replace('/', ''))} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_addcart.png" alt="icon"/>
                    </div>
                </div>
            </div>
        </li>
    )
}
const ItemProductGiftList = ({ item, index }) => {
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    const percen = +item?.price['discount'] / item.price['raw'] * 100;
    const handleRedirect = (uri) => {
        if(uri !== '/undefined'){
            window.location.href =  uri;
        }
    }
    return (
        <li key={item.sku + index} >
            <div className="col-5 img-item in-f">
                <div className="col-7" onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))}>
                    <img className="size-img-list-item-gift" src={item.thumbnail} alt={item.name} title={item.name} />
                    {
                        +item?.price['discount'] !== +item?.price['raw'] ? (<div className="box-sale-percent"><span>{RoundFloor(100 - percen)}%</span></div>) : (null)
                    }
                </div>
                <div className="col-5">
                    <div className="item-gift">
                        <div className="text-gift">
                            <span>tặng</span>
                        </div>
                        <div className="">
                            {/* {
                                item.thumbnail_gifts?.length > 0 ? (
                                    <Carousel key=""
                                    responsive={ResponsiveSliderTop}
                                    showDots={true}
                                    autoPlay={true}
                                    autoPlaySpeed={1000}
                                    infinite={true}
                                    >
                                        {
                                            item.thumbnail_gifts.map((_item,j)=>{
                                                return <img key={j} className="img-gift" src={_item} alt={item.name}/>
                                            }) 
                                        }
                                            
                                    
                                    </Carousel>                          
                                ):(null)
                            } */}
                            <img className="img-gift-mobile" src={item.thumbnail_gifts[0]} alt={item.name} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-7 pdl-10">
                <div className="col-12 box-name-item d-flex" onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))}>
                {/* <h1 className="d-none">{item?.name}</h1> */}
                    <span className="name-item">
                        {
                            item?.name?.length > 50 ? ((item?.name).substring(0, 50) + '...') : (item?.name)
                        }
                    </span>
                </div>
                <div className="col-12 item-sale mgt-10">
                    <span className="price-now"> {
                        +item?.price['discount'] < +item?.price['raw'] ? (
                            FromatNumberVIE(item?.price['raw'])
                        ) : (FromatNumberVIE(item?.price['discount']))
                    }đ</span>
                </div>
                <div className="col-12 in-f mgt-10 pdr-10">
                    <div className="col-12 box-list box-item-sale-none-bg-red-black">
                        <span>Mua là có Quà</span>
                    </div>
                </div>
            </div>
        </li>
    )
}

const Item = ({ item, index }) => {
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    const percen = +item?.price['discount'] / item.price['raw'] * 100;
    const location = useLocation();
    const handleAddToCart = (item, uri) => {
        if (isAuth() === false) {
            //toast.error('Bạn cần đăng nhập trước khi mua hàng.');
            setTimeout(() => { window.location.href = '/dang-nhap.html' }, 3500);
        } else {
            if (item.sku.includes('C') === true || +item.typePromotion === 3) {
                window.localStorage.setItem('typepage', 'product');
                window.location.href = uri;
            } else {
                let params = {
                    items: [{
                        product: item.sku,
                        type: 'item',
                        action: 'add',
                        quantity: 1,
                        promo_code: item.promoCode?? "",
                        combo_code: item.combCode ?? '',
                        uudai: item.uuDai,
                        user_referral:  window.localStorage.getItem('userReferral'),
                        id_share:   window.localStorage.getItem('idShare')
                    }]
                }
                try {
                    actionCart(params, window.localStorage.getItem('key')).then((response) => {
                        if(+response.status === 200 && response.message?.length > 0){
                        localStorage.removeItem("itemsCart");
                        localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                        window.localStorage.setItem('reloadCart', true);
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push({
                                'event': 'add_to_cart',
                                'ecommerce': {
                                'currency': "VND",
                                'value': +item.price?.import,
                                    'items': [
                                    {
                                        item_id: item.sku,
                                        item_name: item.name,
                                        price: +item.price?.import
                                    }
                                    ]
                                }
                            });
                        try{
                                pushtracking(window.localStorage.getItem('sessionId')??null,
                                window.localStorage.getItem('_id')??null,
                                window.localStorage.getItem('phone')??null ,
                                location.pathname, "Thêm sản phẩm vào giỏ hàng", 0,0,'index','inWeb',[item.sku],'Website Mobile').then((response)=>{
                                    console.log('send tracking');
                                });
                            }catch(e){console.log(e)}
                        toast.success('Thêm vào giỏ hàng thành công.');
                        }
                    });
                } catch (err) {
                    console.log(err);
                }
            }
        }
    }
    const handleRedirect = (uri) => {
        if(uri !== '/undefined'){
            window.location.href =  uri;
        }
    }
    const [wishlist, setWishlist] = useState(false);
    const handleWishlist = (sku, isFavorite) => {
        if (window.localStorage.getItem('key')) {
            setWishlist(!wishlist);
            checkWWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                console.log(response);
            })

            if (isFavorite) {
                deleteWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                    console.log(response);
                })
            } else {
                let param = {
                    "code": window.localStorage.getItem('_id'),
                    "user_id": window.localStorage.getItem('_id'),
                    "name": "danh-sach-yeu-thich",
                    "source": "cusapp",
                    "type": "",
                };
                createWishlist(param).then((response) => {
                    if (+response.status === 200) {
                        let data = {
                            "wishlist_id": window.localStorage.getItem('_id'),
                            "user_id": window.localStorage.getItem('_id'),
                            "product_id": sku,
                        };
                        addProductToWishlist(data).then((response) => {
                            console.log(response);
                        })
                    }
                })
            }
        }
    }
    return (
        <React.Fragment>
            <li key={index + item.sku} >
                <div className="box-detail">
                    <div className="col-12 img-item in-f img-item-list-product position-relative" >
                    <div className="img-item-hotdeal">
                        <img onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))} key="size-img" className="w-100 h-100" src={item.thumbnail?.replace('/origin', '/thumb')} alt={item.name}  title={item.name}/>
                    </div>

                    {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['mobileDefault']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ item.labelPromo['position']['bottom'],
                                zIndex:1
                        }):({
                            width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1
                    })
                                
                            }/>
                        ):(null)
                    }
                        <img onClick={() => handleWishlist(item.sku, item.isFavorite)} className="img-like" src={wishlist || item.isFavorite ? ("/../images/web_app/ic_like_active.svg") : ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_like.png")} alt="icon" title="icon"/>
                        {
                            +item?.price['discount'] < +item?.price['raw'] ? (<div className="box-sale-percent"><span>-{RoundFloor(100 - percen)}%</span></div>) : (null)
                        }
                    </div>
                    <div className="col-12 box-name-item pdx-8 d-flex" onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))}>
                    {/* <h1 className="d-none">{item?.name}</h1> */}
                        <span className="name-item">{
                            item?.name?.length > 50 ? ((item?.name).substring(0, 50) + '...') : (item?.name)
                        }</span>
                    </div>
                    <div className="col-12 mgt-5 pdx-8">
                        {
                            +item?.price['discount'] < +item?.price['raw'] ? (
                                <>
                                    <span className="price-item pdr-5">{
                                        FromatNumberVIE(item?.price['discount'])
                                    }đ</span>
                                    <span className="price-sale">{
                                        FromatNumberVIE(item?.price['raw'])
                                    }đ</span>
                                </>

                            ) : (<span className="price-item ">{
                                FromatNumberVIE(item?.price['raw'])
                            }đ</span>)
                        }
                    </div>
                    <div className="col-12 in-f mgt-5 mgb-5 pdx-8">
                        <div className="col-10 mgr-5">

                            {
                                // && item?.namePromotion !== 'Mua là có quà' 
                                item.typePromotion  && item?.namePromotion !== '' ? (

                                    (() => {
                                        switch (+item.typePromotion) {
                                            case 3:
                                                return <div className="box-list box-item-sale-bg">
                                                    {
                                                        item.namePromotion?.length > 0 ? (
                                                            <span>{item.namePromotion}</span>
                                                        ) : (null)
                                                    }
                                                </div>
                                            case 4:
                                                return <div className="box-list box-item-sale-none-bg-border-origin">
                                                    {
                                                        item.namePromotion?.length > 0 ? (
                                                            <span>{item.namePromotion}</span>
                                                        ) : (null)
                                                    }
                                                </div>
                                            case 6:
                                                return <div className="box-list box-item-sale-none-bg-border-red">
                                                    {
                                                        item.namePromotion?.length > 0 ? (
                                                            <span>{item.namePromotion}</span>
                                                        ) : (null)
                                                    }
                                                </div>
                                            default:
                                                return <div className="box-list box-item-sale-bg">
                                                    {
                                                        item.namePromotion?.length > 0 ? (
                                                            <span>{item.namePromotion}</span>
                                                        ) : (null)
                                                    }
                                                </div>
                                        }
                                    })()

                                ) : (null)

                            }
                        </div>
                        <div className="col-2 in-f">
                            <img className="svg-addcart" onClick={() => handleAddToCart(item, '/' + item.linksp?.replace('/', ''))} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_addcart.png" alt="icon"/>
                        </div>
                    </div>
                </div>
            </li>
        </React.Fragment>
    )
}

const ItemDefault = ({ item, index }) => {
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    const handleRedirect = (uri) => {
        window.location.href =  uri;
    }
    useEffect(() => {
    }, [item])
    return (
        <>
            <div className="row pd-5 mgx-0" key={index + item.sku} onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))}>
            {/* <h1 className="d-none">{item?.name}</h1> */}
                <div className="col-12 img-item box-img in-f  position-relative">
                <div className="img-item-default">
                    <img src={item.thumbnail?.replace('/origin', '/thumb')} alt={item.name} />
                </div>
                {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['mobileDefault']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ item.labelPromo['position']['bottom'],
                                zIndex:1
                        }):({
                            width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1
                    })
                                
                            }/>
                        ):(null)
                    }
                </div>

                <div className="col-12 mgt-5 pdx-8">
                    <div className="d-flex">
                        <span className="name-similar">
                            {
                                item?.name?.length > 22 ? ((item?.name).substring(0, 22) + '...') : (item?.name)
                            }</span>
                    </div>
                    <span className="price-similar">
                        {
                            +item?.price['discount'] < +item?.price['raw'] ? (FromatNumberVIE(item?.price['discount'])) : (FromatNumberVIE(item?.price['raw']))
                        }
                        đ</span>
                </div>
                <div className="col-12 in-f mgt-5 mgb-5 pdx-8">
                    <div className="col-1 in-f">
                    </div>
                    {
                        item.namePromotion?.length > 0 ? (
                            <div className="col-9 box-list box-item-sale-bg">
                                <span>{item.namePromotion}</span>
                            </div>
                        ) : (null)
                    }
                    <div className="col-2 in-f">
                    </div>
                </div>
            </div>
        </>
    )
}

const ItemDefaultGift1 = ({ item, index , handleListMinusClick, handleListPlusClick}) => {
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    const handleRedirect = (uri) => {
        window.location.href =  uri;
    }
    useEffect(() => {
    }, [item])
    const [wishlist, setWishlist] = useState(false);
    const handleWishlist = (sku, isFavorite) => {
        if (window.localStorage.getItem('key')) {
            setWishlist(!wishlist);
            checkWWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                console.log(response);
            })

            if (isFavorite) {
                deleteWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                    console.log(response);
                })
            } else {
                let param = {
                    "code": window.localStorage.getItem('_id'),
                    "user_id": window.localStorage.getItem('_id'),
                    "name": "danh-sach-yeu-thich",
                    "source": "cusapp",
                    "type": "",
                };
                createWishlist(param).then((response) => {
                    if (+response.status === 200) {
                        let data = {
                            "wishlist_id": window.localStorage.getItem('_id'),
                            "user_id": window.localStorage.getItem('_id'),
                            "product_id": sku,
                        };
                        addProductToWishlist(data).then((response) => {
                            console.log(response);
                        })
                    }
                })
            }
        }
    }
    return (
        <>
            <div className="pdr-10">
                <div className="box-detail">
                  <div className="col-12 img-item in-f  position-relative">
                  <img key="size-img" className="size-img" src={item.thumbnail} alt={item.name}  title={item.name} />
                    {/* <img onClick={() => handleWishlist(item.sku, item.isFavorite)} className="img-like" src={wishlist || item.isFavorite ? ("/../images/web_app/ic_like_active.svg") : ("/../images/web_app/ic_like.svg")} alt="icon"/> */}
                  {/* <img onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))} key="size-img" className="size-img" src={item.thumbnail} alt={item.name}  title={item.name} /> */}
                    <img onClick={() => handleWishlist(item.sku, item.isFavorite)} className="img-like" src={wishlist || item.isFavorite ? ("/../images/web_app/ic_like_active.svg") : ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_like.png")} alt="icon"/>
                  </div>
                  {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['mobileDefault']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ item.labelPromo['position']['bottom'],
                                zIndex:1
                        }):({
                            width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1
                    })
                                
                            }/>
                        ):(null)
                    }
                  <div className="col-12 box-name-item pdx-8 d-flex">
                  {/* <h1 className="d-none">{item?.name}</h1> */}
                    <span className="name-item">
                    {
                        item?.name?.length > 40 ? ((item?.name).substring(0, 50) + '...') : (item?.name)
                    }
                    </span>
                  </div>
                  <div className="col-12 mgt-5 pdx-8">
                    <span className="price-item">
                    {
                            +item?.price['discount'] < +item?.price['raw'] ? (
                                <>
                                    <span className="price-item pdr-5">{
                                        FromatNumberVIE(item?.price['discount'])
                                    }đ</span>
                                    <span className="price-sale">{
                                        FromatNumberVIE(item?.price['raw'])
                                    }đ</span>
                                </>

                            ) : (<span className="price-item ">{
                                FromatNumberVIE(item?.price['raw'])
                            }đ</span>)
                        }
                    </span>
                  </div>
                  <div className="col-12 in-f mgt-5 mgb-5 pdx-8">
                    <div className={item.quantityPick > 0 ?("detail-number-gift in-f select-num"):("detail-number-gift in-f")}>
                      <div className="number-minus-gift in-f">
                        <i className="fa fa-minus fa-xs" onClick={() => handleListMinusClick(item.sku, item, false)}></i>
                      </div>
                      <div className="pdx-10">
                       <input className="number-now-gift in-f" id={"quantity_" + item.sku} name="quantity" readOnly value={item.quantityPick ? item.quantityPick : 0}/>
                        {/* <input className="number-now-gift in-f" id={"quantity_" + item.sku} name="quantity" readOnly="" value={ 0}/> */}
                      </div>
                      <div className="number-plus-gift in-f"> 
                        <i className="fa fa-plus fa-xs" onClick={() => handleListPlusClick(item.sku, item, false)}></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
        </>
    )
}

export { ItemHotDeal, ItemProductGift, ItemProductGiftList, Item, ItemDefault, ItemDefaultGift1 };